var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMulticolorGradientBold = function SvgMulticolorGradientBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1429,
    height: 1231,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 1429 1231"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E36F1",
    d: "M-11 0h1440v1231H-11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M-11 0h1440v1231H-11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M-11 0h1440v1231H-11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-11 0h1440v1231H-11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M-11 0h1440v1231H-11z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-783.76006 -351.31539 509.79213 -1137.3106 1429 1231)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA12F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(73.114 31.796 717.37)scale(1156.38 994.993)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2059",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(38.755 -941.576 350.86)scale(1104.75 1521.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E36F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#9E36F1",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-209.93356 1148.0129 -617.9409 -113.00094 862.953 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C799",
    stopOpacity: 0
  })))));
};
export { SvgMulticolorGradientBold as ReactComponent };
export default "data:image/svg+xml;base64,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";